// React
import React, { useEffect, useState } from "react";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoSelect from "../../../components/Inputs/GoSelect";
import GoDrawer from "../../../components/Inputs/GoDrawer";
// Services
import { get, put } from "../../../services/FetchHelper";
import ConfigService from "./Config.service";
import SpinService from "../../../services/SpinService";
import { downloadFile } from "../../../services/AwsService";
// Utils
import Config from "./Config";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import Filter from "./Filter";

import InvoiceGeneration from "./InvoiceGeneration";

const initialFilter = { sort: "id", order: "desc", max: 10, offset: 0, search: "", queryFilters: "{}" };
const nonfilterComponents = ["initial", "Areas", "Departments", "Cheque Transaction Setups", "Bank Details", "Suppliers", "Customers", "Currencies", "Mode Of Pay", "Finance Transaction Code Setups", "Bus Details", "Class Promotions", "Main Group Ledgers", "Invoice Generations"];
const nonPages = ["initial", "Invoice Generations"];
const Configurations = () => {
    const permission = usePermissions();
    const spinService = SpinService();
    const [filter, setFilter] = useState(initialFilter);
    const [openFilter, setOpenFilter] = useState(false);
    const [modules, setModules] = useState([]);
    const [config, setConfig] = useState({ componentName: "initial" });
    const [open, setOpen] = useState(false);
    const [master, setMaster] = useState({
        entries: [],
        total_count: 0
    });
    const [masterId, setMasterId] = useState(undefined);

    const getMasters = async () => {
        spinService.on();
        const response = await get(config.entityApi, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}&queryFilters=${filter.queryFilters}`);
        const data = await response.json();
        setMaster(data);
        spinService.off();
    };

    const onView = (row) => {
        if (config.componentName === "Forms") {
            download(row);
        } else {
            setMasterId(row.id);
            setOpen(true);
        }
    };

    const handleChange = (event) => {
        setFilter(initialFilter);
        setConfig(event.target.value);
    };

    const onClose = () => {
        setMasterId(undefined);
        getMasters();
        setOpen(false);
        setOpenFilter(false);
    };

    useEffect(() => {
        if (nonPages.indexOf(config.componentName) === -1) {
            getMasters();
        }
    }, [filter, config]);

    useEffect(() => {
        let filterdMenus = Config.filter((item) => permission.has(item.viewPermission));
        setModules(filterdMenus);
        setConfig(filterdMenus[0])
    }, []);

    const download = async (row) => {
        downloadFile(`forms/${row.file_name}`);
    };

    const onSwitch = async (e) => {
        spinService.on();
        const response = await put(config.entityApi + `/${e.id}`, { [config.objectName]: { status: !e.status } });
        if ([200, 201].indexOf(response.status) > -1) {
            getMasters();
        }
        spinService.off();
    };

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h6"
                        component="div"
                        sx={{ flexGrow: 1 }}>
                        Configurations {config.componentName !== "initial" && `- ${config.componentName}`}
                    </Typography>
                    <GoSelect
                        title="Select Master"
                        name="master"
                        value={config}
                        items={modules}
                        displayKey="componentName"
                        itemValue="fullItem"
                        handleChange={(e) => handleChange(e)}
                        size="small"
                    />
                    {permission.has(config.addPermission) &&
                        <Button
                            variant="contained"
                            startIcon={<Iconify icon="eva:plus-fill" />}
                            onClick={() => setOpen(true)}
                        >
                            New
                        </Button>}
                </Stack>
                {
                    nonPages.indexOf(config.componentName) === -1 && <Card>
                        <GoTable
                            tableHeads={config.tableHeader}
                            tableDatas={master.entries}
                            totalCount={master.total_count}
                            filter={filter}
                            onFilter={(filter) => setFilter((prevState) => {
                                return {
                                    ...prevState,
                                    sort: filter.sort,
                                    order: filter.order,
                                    max: filter.max,
                                    offset: filter.offset,
                                    search: filter.search,
                                }
                            })}
                            onView={(row) => onView(row)}
                            onSwitch={(e) => onSwitch(e)}
                            openFilter={() => setOpenFilter(true)}
                            customFilter={nonfilterComponents.indexOf(config.componentName) === -1}
                        />
                    </Card>
                }
                {config.componentName === "Invoice Generations" && <InvoiceGeneration />}
            </Container>
            {
                config.componentName !== "initial" && open && <GoDrawer
                    title={config.title}
                    open={open}
                    onClose={() => onClose()}
                >
                    <ConfigService name={config.title} onClose={() => onClose()} id={masterId} />
                </GoDrawer>
            }
            {
                openFilter && <Filter
                    componentName={config.componentName}
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }
        </React.Fragment>
    );
};

export default Configurations;